import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Button from '../../../../../pip/apps/MyAccount/components/Button';
import Submit from './Submit';
import Success from './Success';
import RenderError from './RenderError';
import DeleteApplication from './DeleteApplication';
import Messages from './Messages';
import { disableButtonByStatus } from '../../../helpers';

function EquipmentForm({ applicationData, setApplicationData, children }) {
  const initialView = {
    BasicInfo: false,
    ReplacementAssessment: false,
    CurrentPractices: false,
    NewEquipment: false,
    PurchasingDecision: false,
    Messages: false
  };
  const aid = applicationData.aid ?? '';
  const [messages, setMessages] = useState([]);
  const [view, setView] = useState(initialView);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState('');
  const [success, setSuccess] = useState('');
  const [disableSubmit, setDisableSubmit] = useState(true);
  const [unreadMessages, setUnreadMessages] = useState(
    applicationData.unread_messages
    );

  const handleShowForm = (form) => {
    setView({ ...view, [form]: !view[form] });
  };

  const classes = ['u--padding-left-0', 'fip'];

  useEffect(() => {
    const {
      fip_basic_info_section_completed = 0,
      fip_current_practices_section_completed = 0,
      fip_replacement_assessment_section_completed = 0,
      fip_new_equipment_section_completed = 0,
      fip_purchase_decision_section_completed = 0
    } = applicationData;

    let allSectionsComplete =
      fip_basic_info_section_completed == 1 &&
      fip_current_practices_section_completed == 1 &&
      fip_replacement_assessment_section_completed == 1 &&
      fip_new_equipment_section_completed == 1 &&
      fip_purchase_decision_section_completed == 1;

    if (allSectionsComplete && !disableButtonByStatus(applicationData.status)) {
      setDisableSubmit(false);
    } else {
      setDisableSubmit(true);
    }
  }, [applicationData]);

  const handleSubmitApplication = (event) => {
    event.preventDefault();
    setErrors('');
    setLoading(true);
    setDisableSubmit(true);
    let data = new FormData();
    data.append('aid', aid);

    axios
      .post(
        window.wlPipConfig.ajaxUrl +
          '?action=wl_fip_submit_equipment_application',
        data
      )
      .then((res) => {
        let closeAllSections = { ...view };
        Object.keys(closeAllSections).forEach((section) => {
          closeAllSections[section] = false;
        });
        setView(closeAllSections);
        setLoading(false);
        setSuccess(res.data.data.message);
      })
      .catch((err) => {
        setLoading(false);
        setErrors(err.response.data.data);
      });
  };

  const renderForm = (view) => {
    const forms = {
      Messages: Messages
    };
    children.length > 1
      ? children.forEach((section) => {
          Object.assign(forms, { [section.type.displayName]: section.type });
        })
      : Object.assign(forms, { [children.type.displayName]: children.type });
    const Form = forms[view];

    if (view === 'Messages') {
      return (
        <Form
          applicationData={applicationData}
          setApplicationData={setApplicationData}
          messages={messages}
          setMessages={setMessages}
          setUnreadMessages={setUnreadMessages}
        />
      );
    } else {
      return (
        <Form
          applicationData={applicationData}
          setApplicationData={setApplicationData}
          initialView={initialView}
          setView={setView}
        />
      );
    }
  };

  return (
    <div style={{ maxWidth: '600px' }}>
      <Button
        id="fip-basic-info"
        complete={
          applicationData.fip_basic_info_section_completed == 1 ? true : false
        }
        handleClick={() => handleShowForm('BasicInfo')}
        btnText="Basic Info"
        icon={`btn--pip-accordion ${
          view.BasicInfo && 'btn--pip-accordion--on'
        }`}
        classes={classes}
      />
      {view.BasicInfo && renderForm('BasicInfo')}
      <Button
        id="fip-engine-use"
        complete={
          applicationData.fip_current_practices_section_completed == 1
            ? true
            : false
        }
        handleClick={() => handleShowForm('CurrentPractices')}
        btnText="Current Practices & Use"
        icon={`btn--pip-accordion ${
          view.CurrentPractices && 'btn--pip-accordion--on'
        }`}
        classes={classes}
      />
      {view.CurrentPractices && renderForm('CurrentPractices')}
      <Button
        id="fip-replacement_assessment"
        complete={
          applicationData.fip_replacement_assessment_section_completed == 1
            ? true
            : false
        }
        handleClick={() => handleShowForm('ReplacementAssessment')}
        btnText="Replacement Assessment"
        icon={`btn--pip-accordion ${
          view.ReplacementAssessment && 'btn--pip-accordion--on'
        }`}
        classes={classes}
      />
      {view.ReplacementAssessment && renderForm('ReplacementAssessment')}
      <Button
        id="fip-new-equipment"
        complete={
          applicationData.fip_new_equipment_section_completed == 1
            ? true
            : false
        }
        handleClick={() => handleShowForm('NewEquipment')}
        btnText="New Propane-Fueled Equipment"
        icon={`btn--pip-accordion ${
          view.NewEquipment && 'btn--pip-accordion--on'
        }`}
        classes={classes}
      />
      {view.NewEquipment && renderForm('NewEquipment')}
      <Button
        id="fip-purchasing-decision"
        complete={
          applicationData.fip_purchase_decision_section_completed == 1
            ? true
            : false
        }
        handleClick={() => handleShowForm('PurchasingDecision')}
        btnText="Purchasing Decision"
        icon={`btn--pip-accordion ${
          view.PurchasingDecision && 'btn--pip-accordion--on'
        }`}
        classes={classes}
      />
      {view.PurchasingDecision && renderForm('PurchasingDecision')}
      <Submit
        loading={loading}
        disabled={disableSubmit}
        handleSubmit={handleSubmitApplication}
        text="Submit Application"
        errors={errors}
        success={success}
        btnClasses={['u--margin-bottom-0']}
      />
      {errors && <RenderError error={errors} />}
      {applicationData.receipt_notice && <RenderError error={applicationData.receipt_notice} />}
      {success && (
        <div className="u--margin-top-20">
          <Success success={success} />
        </div>
      )}
      <Button
        id="fip-messages"
        complete={false}
        handleClick={() => handleShowForm('Messages')}
        btnText="Messages"
        icon={`btn--pip-accordion ${
          view.Messages && 'btn--pip-accordion--on'
        }`}
        classes={[...classes, 'u--margin-top-20']}
        unreadMessages={unreadMessages}
      />
      {view.Messages && renderForm('Messages')}
      {aid && <DeleteApplication applicationData={applicationData} />}
    </div>
  );
}

export default EquipmentForm;
